/* Decorative light only: no click, form, pricing or navigation handlers. */
(()=>{
 if(window.vendifoxPremiumV10)return;
 window.vendifoxPremiumV10=true;
 const motion=matchMedia('(prefers-reduced-motion: no-preference) and (hover: hover) and (pointer: fine)');
 let frame=0,active=null;
 function stop(){cancelAnimationFrame(frame);frame=0;if(active){active.el.style.removeProperty('--vf10-x');active.el.style.removeProperty('--vf10-y');active=null;}}
 function paint(){
  frame=0;if(!active||!motion.matches||document.hidden){stop();return;}
  const a=active;a.x+=(a.tx-a.x)*.1;a.y+=(a.ty-a.y)*.1;
  a.el.style.setProperty('--vf10-x',a.x.toFixed(2)+'%');a.el.style.setProperty('--vf10-y',a.y.toFixed(2)+'%');
  if(Math.abs(a.tx-a.x)+Math.abs(a.ty-a.y)>.1)frame=requestAnimationFrame(paint);
 }
 function init(){document.querySelectorAll('.vf3-model-stage,.vf7-cutout-media .vf6-enlarge').forEach(el=>{
  if(el.dataset.vf10Light)return;el.dataset.vf10Light='true';
  el.addEventListener('pointermove',e=>{
   if(!motion.matches||document.hidden||e.pointerType!=='mouse')return;
   if(!active||active.el!==el){stop();active={el,x:50,y:82,tx:50,ty:82};}
   const rect=el.getBoundingClientRect();if(!rect.width||!rect.height)return;
   active.tx=25+Math.max(0,Math.min(1,(e.clientX-rect.left)/rect.width))*50;
   active.ty=40+Math.max(0,Math.min(1,(e.clientY-rect.top)/rect.height))*45;
   if(!frame)frame=requestAnimationFrame(paint);
  },{passive:true});
  el.addEventListener('pointerleave',stop,{passive:true});
 });}
 document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();});
 document.addEventListener('shopify:section:load',init);
 motion.addEventListener('change',stop);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
